<template> 
  <div
    class="overlay z-30"
    tabindex="0"
  >
    <div
      class="dialog bet-list-dialog divide-y"
      style="max-width: 400px;"
    >
      <div class="dialog-title">
        <div class="flex items-center gap-2">
          ใส่จำนวนเดิมพัน
        </div>
        <button
          id="back-dialog-btn"
          class="icon"
          type="button"
          @click="close"
        >
          <div class="flex items-center justify-center">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            ></path></svg>
          </div>
        </button>
      </div>
      <div class="overflow-x-auto h-96 rounded-none">
        <table class="relative">
          <div
            v-for="(item, i) in numberConditions"
            v-show="dataFilter(item).length!==0"
            :key="i"
            class="w-full"
          >
            <!-- {{  item }} -->
            <thead class="border-t first:border-t-0">
              <tr>
                <th class="py-1 w-full">
                  <div class="flex items-center gap-1">
                    {{ item.number_type.name }} 
                  </div>
                </th><th class="py-1 text-right">
                  เรทจ่าย
                </th><th class="py-1 text-right px-0">
                  จำนวน
                </th><th class="py-1 text-center">
                  ลบ
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(itemJ, j) in dataFilter(item)"
                :key="j"
              >
                <td>
                  <div class="flex items-center gap-1 font-semibold">
                    {{ itemJ.number }}
                  </div>
                </td>
                <td class="text-right">
                  {{ item.userReward | number_comma }}
                </td>
                <td class="px-0 py-2">
                  <label
                    inputmode="numeric"
                    placeholder="ใส่จำนวน"
                    class="h-8 min-w-[100px] text-right"
                    disabled="false"
                    min="1"
                  >
                    <div class="font-medium"></div>
                    <div class="input-group relative mb-0">
                      <span
                        class="prepend"
                        style="display: none;"
                      ></span>
                      <input
                        v-model="itemJ.unit"
                        inputmode="numeric"
                        placeholder="ใส่ราคา"
                        class="h-8 min-w-[100px] text-right w-full price-input"
                        min="1"
                        type="number"
                        @keydown="autoCheck (itemJ, item, $event)"
                      ><span
                        class="append"
                        style="display: none;"
                      ></span></div></label>
                </td>
                <td class="text-center">
                  <button
                    class="icon text error2"
                    type="button"
                    @click="delValue(itemJ)"
                  >
                    <div class="flex items-center justify-center">
                      <svg
                        data-v-aee14c88=""
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                      ><path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                      ></path></svg>
                    </div>
                  </button>
                </td>
              </tr>
            </tbody>
          </div>
        </table>
        <div 
          v-if="!isFoundData"
          class="w-full flex justify-center mt-2"
        >
          <span>
            ไม่พบเลขเดิมพัน
          </span>
        </div>
      </div>
      
      <div class="dialog-actions grid grid-cols-2 gap-2 mb-2">
        <button
          id="look-duplicate-btn"
          class="w-full"
          type="button"
          @click="showDuplicateNumber = !showDuplicateNumber"
        >
          <div class="btn-look-duplicate flex items-center justify-center font-bold">
            <span v-if="!showDuplicateNumber">ดูเลขซ้ำ</span>
            <span v-else>ดูเลขทั้งหมด</span>
          </div>
        </button>
        <button
          id="remove-duplicate-btn"
          class="w-full"
          type="button"
          @click="removeDuplicate"
        >
          <div class="btn-remove-duplicate flex items-center justify-center font-bold">
            <span>ตัดเลขซ้ำ</span>
          </div>
        </button>
      </div>

      <div class="dialog-actions grid gap-2 grid-cols-6">
        <button
          v-for="price in presetPrice"
          :key="price.amount"
          class="h-8"
          :class="price.class"
          type="button"
          @click="onSelectPreset(price)"
        >
          <div class="flex items-center justify-center">
            {{ price.amount }}
          </div>
        </button>
      </div>
      <div class="dialog-actions flex items-center gap-4">
        <span class="whitespace-nowrap">ใส่จำนวน (ทั้งหมด)</span><div class="flex w-full items-center gap-1">
          <label
            modelmodifiers="[object Object]"
            inputmode="numeric"
            placeholder="ใส่จำนวน"
            class="h-8 text-right"
            disabled="false"
          ><div class="font-medium"></div><div class="input-group relative mb-0"><span
                                                                                   class="prepend"
                                                                                   style="display: none;"
                                                                                 ></span>
            <input
              v-model="allPrice"
              inputmode="numeric"
              placeholder="ใส่ราคา"
              class="h-8 text-right w-full price-input"
              type="number"
            ><span
              class="append"
              style="display: none;"
            ></span></div>
          </label>
        </div>
      </div>
      <div class="dialog-actions member-balance flex items-center justify-between gap-2">
        <span class="item-title">เงินคงเหลือ (บาท)</span><span class="item-value animate-slide-left font-semibold">{{ wallet.amount | currency }}</span>
      </div>
      <div class="dialog-actions bet-amount flex items-center justify-between gap-2">
        <span class="item-title">ยอดรวม (บาท)</span><span class="item-value animate-slide-left font-semibold">{{ sumUserPrice | currency }}</span>
      </div>
      <div
        v-if="errorMessage"
        class="dialog-actions text-xs flex items-center justify-between gap-2 red--text"
      >
        <span>{{ errorMessage }}</span>
      </div>
      
      <div class="dialog-actions grid grid-cols-2 gap-2">
        <button
          id="bet-remove-btn"
          class="bg-error/10 text-error"
          type="button"
          @click="clearAll"
        >
          <div class="flex items-center justify-center">
            ลบทั้งหมด
          </div>
        </button>
        <button
          id="to-deposit-btn"
          class="w-full"
          type="button"
          @click="addStake"
        >
          <div class="btn-confirm flex items-center justify-center font-bold">
            <v-progress-circular
              v-if="isConfirmLoading"
              color="white"
              model-value="10"
              size="20"
              width="2"
              indeterminate
            ></v-progress-circular>
            <span>แทงพนัน</span>
          </div>
        </button>
      </div>
    </div>
    <dialogconfirmaddstake 
      ref="confirmAddstake"
      @load="load"
    />
  </div>
</template>
<script>
import { gameRooms as apiGameRooms } from '@/apis'
import dialogconfirmaddstake from './ResultPriceCard/childs/ConfirmAddStake'

export default { 
  components: {
    dialogconfirmaddstake
  },
  props:{
    numberConditions:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      },
    },
    voucher:{
      type: Object,
      default:()=>{}
    }
  },
  data () {
    return { 
      allPrice: 1,
      errorMessage: null,
      isConfirmLoading: false,
      showDuplicateNumber: false
    }
  }, 
  computed : {
    routeId () {
      return this.$route.query.id
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    presetPrice () {
      return [
        { amount: 5, class: 'bg-slate-400'},
        { amount: 10, class: 'bg-amber-400'},
        { amount: 20, class: 'bg-emerald-500'},
        { amount: 50, class: 'bg-sky-500'},
        { amount: 100, class: 'bg-rose-500'},
        { amount: 500, class: 'bg-violet-500'}
      ]
    },
    sumUserPrice () {
      let total = 0
      
      if(this.userSelect.length>0){
        this.userSelect.forEach(element => { 
            if(element.unit!==null){
              total += element.unit*this.findElement(element.number_type_id).price
            }
        }); 
      } 

      return total
    },

    isFoundData () {
      return this.numberConditions.some(item => {
        const result = this.dataFilter(item);
        return result.length !== 0;
      });
    },

  },
  watch:{
    userSelect () { 
      if (this.userSelect.length == 0) {
        this.close()
      }
    },
    
    allPrice () {
      if(this.allPrice !== null && this.allPrice !== ''){ 
        if(parseInt(this.allPrice)<=0){  
          this.allPrice = 1
        }
        this.allPriceList ()
      } 
    } 
  },
  methods: {
    dataFilter (item){ 
      let numbers = item.number_type ?
        this.userSelect.filter(x=>x.number_type_id===item.number_type.id)
        : [] 
        // .sort((a,b) => a.number - b.number)

        if (this.showDuplicateNumber) {
          const countMap = numbers.reduce((acc, item) => {
            acc[item.number] = (acc[item.number] || 0) + 1;
            return acc;
          }, {});

          return numbers.filter(item => countMap[item.number] > 1).sort((a,b) => a.number - b.number);
        }

        return numbers;
    },

    removeDuplicate () {
      const seen = new Set();
      const items = [...this.userSelect];

      items.forEach(item => {
        const key = `${item.number}-${item.number_type_id}`;

        if (seen.has(key)) {
          this.delValue(item);
        } else {
          seen.add(key);
        }
      });

      this.showDuplicateNumber = false
    },

    close () {
      this.$emit('close');
    },

    load () {
      this.$emit('clearAll');
      this.close()
    },

    clearAll () {

      this.$confirm('',this.$t('confirm.remove-all-stake-list'),'warning').then(()=>{ 
        this.$emit('clearAll');

        this.close()

      }).catch(()=>{});
    },

    delValue (number){  
      this.$ga.event('Button', 'DeleteStakeWeb', 'ResultSelectBet', number)

      this.$emit('delValue',
        null,
        number.number,
        number.number_type_id,
        number.selectNineteen,
        number.selectFrontRoot,
        number.selectBackRoot)
    },

    autoCheck (item, itemCondition, evt) {
      var currentInput = item.unit + evt.key
      
      if(parseInt(currentInput)>itemCondition.max_unit_per_number_per_list){ 
        item.unit=itemCondition.max_unit_per_number_per_list 
        evt.preventDefault()
        // this.sumUserPrice()
        return
      } else if(item.unit[0]==='0') {
        item.unit=1
        evt.preventDefault()
        // this.sumUserPrice()
        return
      }
    },

    findElement (id){
      return this.numberConditions.find(x=>x.number_type.id===id)
    },

    allPriceList () {
      // this.total = 0
      if(this.userSelect.length>0){
        this.userSelect.forEach(element => {
          let condition = this.findElement(element.number_type_id) 
          element.unit = condition.max_unit_per_number_per_list > this.allPrice ? this.allPrice : condition.max_unit_per_number_per_list
          if(element.unit!==null){
            // this.total += element.unit*condition.price
          }
        }); 
      } 
    },

    onSelectPreset (preset) {
      this.allPrice = preset.amount
    },

    async addStake () { 
      var entireStake = []
      var breakStatus = false
      this.submitStatus = true
      this.$ga.event('Submit', 'AddStakeWeb', 'ResultSelectBet', '')
      let stakeQuotaLimit = (this.voucher.rules || {}).stake_quota_limit
      let checkVoucherStakeTotal = this.voucher.rules && stakeQuotaLimit
      
      this.numberConditions.forEach(cond => {
        const items = this.userSelect.filter(x=> x.number_type_id === cond.number_type.id)
        const lengthPerCondition = (items || []).length
        //check max number list per number condition
        if(cond.max_unit_per_number_per_list && cond.max_unit_per_number_per_list < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_unit_per_number_per_list} ${this.$t('unit.unit-per-number-per-list')}`
          return
        }

        //check max number user per number condition
        if(cond.max_number_per_user && cond.max_number_per_user < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_number_per_user} ${this.$t('unit.number-per-user')}`
          return
        }

        items.forEach(element=>{ 
          //check empty field
          if(!breakStatus && (element.unit === null || element.unit==='')) { 
            breakStatus = true
            this.errorMessage=`${this.$t('validate.please-enter-number-numbers')} ${element.number}`
            return
          }   

          // totalPerCondition += parseInt(element.unit || 0)
          entireStake.push({
            number:element.number,
            number_type_id:element.number_type_id,
            unit:element.unit
          }) 
        }) 
      }) 

      await Promise.all(entireStake)

      if(breakStatus) { 
        this.submitStatus = false 
        return
      } 
      
      if(checkVoucherStakeTotal && this.total > parseInt(stakeQuotaLimit)) {
        this.errorMessage=` ${this.$t('number-condition.maximum-bet')} ${stakeQuotaLimit} ${this.$t('unit.credit')}`
        this.submitStatus = false 
        return
      }

      this.isConfirmLoading = true

      if(entireStake.length===0){
        this.errorMessage= this.$t('validate.please-choose-bet-number')
        this.submitStatus = false
      } else if(this.creditAmount - this.total<0){
        this.errorMessage=this.$t('validate.money-not-enough')
        this.submitStatus = false
      } else {
        await this.apiAddStake(this.routeId,entireStake) 
      }

      this.isConfirmLoading = false
    },

    async apiAddStake (id,stakes) {  
      let params = {
        stakes:stakes
      }
      if(this.voucher.uuid) {
        params.voucher_uuid = this.voucher.uuid
      }
      if(this.description){
        params.description = this.description
      } 
      const [err,data] = await apiGameRooms.postAddStake(id,params)
      this.submitStatus = false
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }

      if(data) {
        this.$refs.confirmAddstake.openDialog(data,this.numberConditions)   
      } 
    }, 
  },  
}
</script>
<style scoped>
.z-30 {
  z-index: 300 !important;
}

.overlay {
  align-items: center;
  background-color: rgba(0, 0, 0, .7);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: .5rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 11;
}

.dialog {
  --tw-bg-opacity: 1;
  /* background-color: rgba(251, 239, 231, var(--tw-bg-opacity)); */
  background-color: white;
  border-radius: .5rem;
  display: flex;
}

.dialog {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  flex-direction: column;
  max-height: 100%;
  text-align: left;
  width: 100%;
  z-index: 30;
}

.dialog .dialog-actions, .dialog .dialog-text, .dialog .dialog-title {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.dialog-title {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.2rem;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.5rem;
  padding: .75rem 1rem;
}

.h-8 {
  height: 2rem !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.bg-slate-400 {
  background-color: rgb(148 163 184/ 1) !important;
}

.bg-amber-400 {
  background-color: rgb(251 191 36/ 1) !important;
}

.bg-emerald-500 {
  background-color: rgb(16 185 129/ 1) !important;
}

.bg-sky-500 {
  background-color: rgb(14 165 233/ 1) !important;
}

.bg-rose-500 {
  background-color: rgb(244 63 94/ 1) !important;
}

.bg-violet-500 {
  background-color: rgb(139 92 246/ 1) !important;
}

table {
  border-collapse: collapse;
  border-color: inherit;
  text-indent: 0;
}

table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

table thead tr th {
  --tw-bg-opacity: 1;
  background-color: rgba(46, 30, 30, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  white-space: nowrap;
  line-height: 1.75rem;
  padding: .5rem;
  text-align: left;
  text-transform: capitalize;
  white-space: nowrap;
}

.btn.icon, [type=button].icon, [type=submit].icon, button.icon {
  height: 2rem;
  min-height: 2rem;
  padding: 0;
  width: 2rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.min-w-\[100px\] {
  min-width: 100px !important;
}

table tbody tr:nth-child(2n) {
  background-color: var(--bg-primary-250);
}

.input-group, .select-group .select-button {
  --tw-border-opacity: 1;
  border-color: rgba(var(--color-tertiary), var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(var(--color-background), var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.input-group {
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .25rem;
  color: #374151;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  position: relative;
  transition: all .2s cubic-bezier(.4,0,.2,1);
}

.btn.text, [type=button].text, [type=submit].text, button.text {
  background-color: transparent;
  box-shadow: none;
}

.error2 {
  color: #000;
}

.error2:hover {
  background-color: var(--bg-primary-550);
  border-radius: .2em;
}

.dialog .dialog-actions {
  font-size: 1.2rem;
  padding: .5rem .75rem;
}

.bet-list-dialog #bet-remove-btn {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color:  var(--bg-primary-550);
  font-weight: bold;
  border-style: solid;
}

.bg-error\/10 {
  color:  var(--bg-primary-550);
  /* background-color: rgba(255, 18, 34, .1) !important; */
  background-color: white;
}

table tbody tr td {
  color: #374151;
  font-weight: 500;
  line-height: 1.75rem;
  padding: .5rem;
  white-space: normal;
}

@media (min-width: 640px) {
  table tbody tr td, table thead tr th {
    /* font-weight: 600;font-weight: 600; */
    line-height: 1.5rem;
    padding: .5rem .75rem;
  }
}

.price-input {
   padding: .25rem 1rem;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.btn-confirm {
  gap: 10px;
}

#look-duplicate-btn {
  background-color: #5676ff;
}

#remove-duplicate-btn {
  background-color: #ff5757;
}

</style>